import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_button = _resolveComponent("app-button")!
  const _component_app_card = _resolveComponent("app-card")!
  const _component_app_table = _resolveComponent("app-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isSuperUser)
      ? (_openBlock(), _createBlock(_component_app_card, {
          key: 0,
          label: "Function",
          classes: "mx-auto"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_app_button, {
              name: "Create New App",
              icon: "fa-plus",
              theme: "info",
              to: { name: _ctx.ROUTE_NAME_APPLICATION.ADD }
            }, null, 8, ["to"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_app_card, null, {
      default: _withCtx(() => [
        _createVNode(_component_app_table, {
          rows: _ctx.list,
          columns: _ctx.table.columns,
          total: _ctx.total,
          actions: _ctx.table.actions,
          onRefreshData: _ctx.fetchList
        }, null, 8, ["rows", "columns", "total", "actions", "onRefreshData"])
      ]),
      _: 1
    })
  ], 64))
}